export default function EditPRAProcessDialogController(
  $scope,
  $rootScope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  alerts,
  loaderService,
  praDataService,
  editAssetDialog,
  assignPRAAssetDialog,
  assetDataService,
  assetSharedModelService,
  praSharedModelService,
) {
  const vm = this;

  vm.process.newName = vm.process.name;
  vm.processId = vm.process.processId;
  vm.handleCloseDialog = handleCloseDialog;
  vm.handleAddAsset = _handleAddAsset;
  vm.handleAssignAssets = _handleAssignAssets;
  vm.handleSubmit = handleSubmit;
  // vm.canEditProcess = true;
  vm.canSeeSubmit = true;

  _activate();

  /** ***************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSubmit() {
    loaderService.showViewLoader = true;
    // Check form validity
    if (!$scope.praEditProcessForm.$valid) {
      loaderService.showViewLoader = false;
      return false;
    }

    return _saveProcess(vm.readyToSubmit)
      .then(() => {
        if (vm.readyToSubmit1 === true) {
          const _processIds = [];
          _processIds.push(vm.process.assessmentProcessId);
          praDataService.submitAssessmentProcesses(_processIds)
            .then((saveProcessResponse) => {
              vm.process.dateSubmitted = saveProcessResponse.data[0].dateSubmitted;
              loaderService.showViewLoader = false;
              if (vm.updateCallBack) {
                vm.updateCallBack(vm.process);
              }
              // $rootScope.$broadcast('refreshMainAssessment');
              handleCloseDialog();
            });
        } else {
          loaderService.showViewLoader = false;
          // $rootScope.$broadcast('refreshMainAssessment');
          handleCloseDialog();
        }
      });
  }

  function _handleAddAsset($event) {
    $scope.praEditProcessForm.$submitted = true;
    loaderService.showViewLoader = true;

    if (!$scope.praEditProcessForm.$valid) {
      loaderService.showViewLoader = false;
      return false;
    }

    return _saveProcess()
      .then(() => {
        const _asset = { customerAssetId: 0 };
        return _showEditAssetDialog($event, _asset);
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleAssignAssets($event) {
    $scope.praEditProcessForm.$submitted = true;
    loaderService.showViewLoader = true;

    if (!$scope.praEditProcessForm.$valid) {
      loaderService.showViewLoader = false;
      return false;
    }

    const promises = [
      _saveProcess(),
    ];
    return $q.all(promises)
      .then(() => {
        loaderService.showViewLoader = false;
        ssDialogService.dialogs.pra.assignAssetDialog = ssDialogService.alert(
          assignPRAAssetDialog.getOptions($event, {
            process: vm.process,
            assetTypes: vm.assetTypes,
            assignedAssets: vm.process.assessment.assessmentCustomerAssets
          })
        );
        return ssDialogService.show(ssDialogService.dialogs.pra.assignAssetDialog);
      });
  }

  /** ***************************************
   * Private functions
   */

  function _showEditAssetDialog($event, _asset) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.assetAdmin.editAssetDialog = ssDialogService.alert(
      editAssetDialog.getOptions($event, {
        asset: _asset,
        assetCriticalities: assetSharedModelService.AssetCriticalities,
        assetDataTypes: assetSharedModelService.AssetDataTypes,
        assetDataUses: assetSharedModelService.AssetDataUses,
        assetTypes: assetSharedModelService.AssetTypes,
        updateCallBack: _broadcastAssetChanges,
        process: vm.process
      })
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetDialog);
  }

  function _broadcastAssetChanges() {
    $rootScope.$broadcast('refreshAssessmentProcess');
    $rootScope.$broadcast('refreshMainAssessmentProcess', { process: vm.process });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.editProcessDialog);
  }

  function _saveProcess(submit) {
    if (!_checkAssessmentProcessChanges() && !submit) {
      // No need to save
      return Promise.resolve(); // or return Promise.resolve();
    }

    // The assessment object is huge.  It causes a deceptive CORS error on the API call.
    // Even if it gets there, it is not used. Killing it here. (PRA-875)
    vm.process.assessment = null;
    return praDataService.saveAssessmentProcesses(vm.process.assessmentProcessId, vm.process, submit)
      .then((saveProcessResponse) => {
        alerts.success('The process has been saved.');
        vm.process = saveProcessResponse.data;
        _transformProcessAssets();
        // $rootScope.$broadcast('refreshMainAssessmentProcess', { process: vm.process });
        if (vm.updateCallBack) {
          vm.updateCallBack(vm.process);
        }
      });
  }

  function _activate() {
    vm.process.successions = {};
    if (vm.process.dateSubmitted) {
      vm.readyToSubmit = true;
    }
    vm.process.allAssignedAssets = vm.process.assessment.assessmentCustomerAssets;
    // _transformProcessAssets();
    vm.oldProcess = angular.copy(vm.process);
    $scope.$on(
      'refreshAssessmentProcess',
      () => {
        refreshAssessmentProcess();
      }
    );
    $scope.$watch(() => vm.process.customerRiskAppetiteLevelId, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        vm.readyToSubmit = false;
      }
    });

    $scope.$watch(() => vm.process.notes, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        vm.readyToSubmit = false;
      }
    });
  }

  function refreshAssessmentProcess() {
    const promises = [
      praDataService.getProcessAssetsByType(vm.process.assessmentProcessId),
      praSharedModelService._initPage(),
    ];
    return $q.all(promises)
      .then((getProcessResponse) => {
        try {
          vm.process = getProcessResponse[0].data;
          vm.assetTypes = angular.copy(assetSharedModelService.AssetTypes);
          // eslint-disable-next-line max-len
          vm.process.allAssignedAssets = praDataService.transformAssignedAssets(vm.process.assessment.assessmentCustomerAssets, vm.assetTypes);
          if (vm.process.dateSubmitted) {
            vm.readyToSubmit = true;
          }
          if (!angular.equals(vm.oldProcess, vm.process)) {
            // No need to save
            vm.readyToSubmit = false;
          }
        } catch (error) {
          console.error(error);
        }
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _transformProcessAssets() {
    // eslint-disable-next-line max-len
    vm.process.allAssignedAssets = praDataService.transformAssignedAssets(
      vm.process.assessment.assessmentCustomerAssets,
      vm.assetTypes
    );
  }

  function _checkAssessmentProcessChanges() {
    let change = false;
    // eslint-disable-next-line max-len
    if (vm.process.customerRiskAppetiteLevelId !== vm.oldProcess.customerRiskAppetiteLevelId || vm.process.notes !== vm.oldProcess.notes) {
      change = true;
    }
    return change;
  }
}

EditPRAProcessDialogController.$inject = [
  '$scope',
  '$rootScope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'alerts',
  'loaderService',
  'praDataService',
  'editAssetDialog',
  'assignPRAAssetDialog',
  'assetDataService',
  'assetSharedModelService',
  'praSharedModelService',
];
